import React from 'react';
import { Link } from 'react-router-dom';

function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-center">
      <h1 className="text-4xl font-extrabold text-gray-800">404 - Page Not Found</h1>
      <p className="text-lg text-gray-600 mt-4">Sorry, the page you're looking for doesn't exist.</p>
      <Link to="/" className="mt-6 px-4 py-2 text-lg bg-blue-600 text-white rounded hover:bg-blue-700">
        Go back to Home
      </Link>
    </div>
  );
}

export default NotFoundPage;
